import { Button, type ButtonProps } from '@mui/material';
import type React from 'react';
import SimpleLink from '../link/simple-link';

export type LinkButtonProps = {
  readonly href: string;
} & ButtonProps;

const LinkButton: React.FC<LinkButtonProps> = (props: LinkButtonProps) => {
  const { href, onClick, variant, className, startIcon, fullWidth, color, size, sx } = props;
  return (
    <SimpleLink href={href} fullWidth={fullWidth}>
      <Button
        className={className}
        onClick={onClick}
        variant={variant}
        startIcon={startIcon}
        color={color}
        sx={{ display: 'flex', minWidth: 0, ...sx }}
        fullWidth={fullWidth}
        size={size}
      >
        {props.children}
      </Button>
    </SimpleLink>
  );
};

export default LinkButton;
